module.exports = __webpack_public_path__ + "static/media/info.e24080d1.svg";